export { GlobalFooterComponent } from './global-footer.component';
export { AdGlobalFooterModule } from './global-footer.module';
